// src/Components/InstallModal/InstallModal.js
import React from 'react';
import { Icon } from '@iconify/react';
import './InstallModal.css';

const InstallModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="install-modal-overlay" onClick={onClose}>
            <div className="install-modal" onClick={(e) => e.stopPropagation()}>
                <button className="install-modal__close" onClick={onClose}>
                    <Icon icon="solar:close-circle-linear" />
                </button>

                <div className="install-modal__icon-wrap">
                    <Icon icon="solar:smartphone-linear" className="install-modal__hero-icon" />
                </div>

                <h2 className="install-modal__title">App Coming Soon</h2>
                <p className="install-modal__text">
                    The official AiPredict App is in final review. In the meantime, you can install the 
                    web app directly to your home screen for the exact same experience.
                </p>

                <div className="install-modal__guide">
                    <div className="install-modal__step">
                        <span className="step-number">1</span>
                        <p>Visit aipredict.app page in <strong>Safari</strong> on iPhone.</p>
                    </div>
                    <div className="install-modal__step">
                        <span className="step-number">2</span>
                        <p>Tap the <strong>Share</strong> icon <Icon icon="solar:share-linear" style={{verticalAlign: 'middle'}} /> at the bottom.</p>
                    </div>
                    <div className="install-modal__step">
                        <span className="step-number">3</span>
                        <p>Scroll down and select <strong>"Add to Home Screen"</strong>.</p>
                    </div>
                </div>

                <button className="install-modal__btn" onClick={onClose}>
                    Got it
                </button>
            </div>
        </div>
    );
};

export default InstallModal;